import { IApplicationState } from '../../types/redux';
import { selectUser } from './selectUser';

export const selectUserPhone = (state: IApplicationState) => {
  const user = selectUser(state);
  const phone = user.isAuthenticated && user.phones[0]?.phone;

  return phone ? `+${phone}` : null;
};
